import { useTheme } from "../../../theme/ThemeProvider";
import { ITheme } from "../../../theme/ITheme";
import { IConfigurationStyles } from "../../styles";

export const useConfigurationStyles = (theme?: ITheme): IConfigurationStyles => {
    if (theme === undefined) {
        theme = useTheme();
    }

    return {
        sectionTitle: {
            fontFamily: theme.typography.fontFamily,
            color: theme.palette.text.dark,
            fontSize: theme.font.sizes.xxl,
            textTransform: "none"
        },
        sectionSubtitle: {
            fontFamily: theme.typography.fontFamily,
            color: theme.palette.text.main,
            fontSize: theme.font.sizes.md
        },

        tileTitle: {
            fontFamily: theme.typography.fontFamily,
            color: theme.palette.text.dark,
            fontSize: theme.font.sizes.xl,
            textTransform: "none",
            marginBottom: 0
        },
        titleSubtitle: {
            fontFamily: theme.typography.fontFamily,
            color: theme.palette.text.main,
            fontSize: theme.font.sizes.sm
        },
        tileCaret: {
            color: theme.palette.text.dark,
            fontSize: theme.font.sizes.xl,
        },
    }
}